/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IdpClaimMappingValidationIssue } from './IdpClaimMappingValidationIssue';
import {
    IdpClaimMappingValidationIssueFromJSON,
    IdpClaimMappingValidationIssueFromJSONTyped,
    IdpClaimMappingValidationIssueToJSON,
    IdpClaimMappingValidationIssueToJSONTyped,
} from './IdpClaimMappingValidationIssue';

/**
 * Result of IdP claim mapping validation for a tenant
 * @export
 * @interface IdpClaimMappingValidationResponse
 */
export interface IdpClaimMappingValidationResponse {
    /**
     * 
     * @type {boolean}
     * @memberof IdpClaimMappingValidationResponse
     */
    success?: boolean;
    /**
     * 
     * @type {string}
     * @memberof IdpClaimMappingValidationResponse
     */
    tenantId?: string;
    /**
     * 
     * @type {Array<IdpClaimMappingValidationIssue>}
     * @memberof IdpClaimMappingValidationResponse
     */
    issues?: Array<IdpClaimMappingValidationIssue>;
    /**
     * 
     * @type {string}
     * @memberof IdpClaimMappingValidationResponse
     */
    identityProviderType?: IdpClaimMappingValidationResponseIdentityProviderTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof IdpClaimMappingValidationResponse
     */
    externalValidationAvailable?: boolean;
    /**
     * 
     * @type {string}
     * @memberof IdpClaimMappingValidationResponse
     */
    externalValidationMessage?: string;
    /**
     * 
     * @type {boolean}
     * @memberof IdpClaimMappingValidationResponse
     */
    readonly hasErrors?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IdpClaimMappingValidationResponse
     */
    readonly hasWarnings?: boolean;
}


/**
 * @export
 */
export const IdpClaimMappingValidationResponseIdentityProviderTypeEnum = {
    Azure: 'azure',
    Okta: 'okta',
    Google: 'google',
    Keycloak: 'keycloak',
    Custom: 'custom',
    Integration: 'integration'
} as const;
export type IdpClaimMappingValidationResponseIdentityProviderTypeEnum = typeof IdpClaimMappingValidationResponseIdentityProviderTypeEnum[keyof typeof IdpClaimMappingValidationResponseIdentityProviderTypeEnum];


/**
 * Check if a given object implements the IdpClaimMappingValidationResponse interface.
 */
export function instanceOfIdpClaimMappingValidationResponse(value: object): value is IdpClaimMappingValidationResponse {
    return true;
}

export function IdpClaimMappingValidationResponseFromJSON(json: any): IdpClaimMappingValidationResponse {
    return IdpClaimMappingValidationResponseFromJSONTyped(json, false);
}

export function IdpClaimMappingValidationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): IdpClaimMappingValidationResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'] == null ? undefined : json['success'],
        'tenantId': json['tenant_id'] == null ? undefined : json['tenant_id'],
        'issues': json['issues'] == null ? undefined : ((json['issues'] as Array<any>).map(IdpClaimMappingValidationIssueFromJSON)),
        'identityProviderType': json['identity_provider_type'] == null ? undefined : json['identity_provider_type'],
        'externalValidationAvailable': json['external_validation_available'] == null ? undefined : json['external_validation_available'],
        'externalValidationMessage': json['external_validation_message'] == null ? undefined : json['external_validation_message'],
        'hasErrors': json['has_errors'] == null ? undefined : json['has_errors'],
        'hasWarnings': json['has_warnings'] == null ? undefined : json['has_warnings'],
    };
}

export function IdpClaimMappingValidationResponseToJSON(json: any): IdpClaimMappingValidationResponse {
    return IdpClaimMappingValidationResponseToJSONTyped(json, false);
}

export function IdpClaimMappingValidationResponseToJSONTyped(value?: Omit<IdpClaimMappingValidationResponse, 'has_errors'|'has_warnings'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'tenant_id': value['tenantId'],
        'issues': value['issues'] == null ? undefined : ((value['issues'] as Array<any>).map(IdpClaimMappingValidationIssueToJSON)),
        'identity_provider_type': value['identityProviderType'],
        'external_validation_available': value['externalValidationAvailable'],
        'external_validation_message': value['externalValidationMessage'],
    };
}

